HeaderLinkClickEvents();

$(".mainItem > .MainNavItem > a").live("click", function () {

    $selector = $(this);
    $("#MainMenu").animate({ scrollTop: 0 }, 250, 'swing', function () { });

    setTimeout(function () {
        $selector.parents(".mainItem").children(".itemsWrapper").addClass("ShowWrapper");
    }, 250);

    $a = $(this);
    $(this).parents("#MainMenu").addClass("openSub");
    var dataName = ($a.attr("data-name"));
    if (dataName != undefined && dataName != 'undefined') {
        var newa = "<a data-rel='" + $a.attr("data-rel") + "' data-name='" + $a.attr("data-name") + "' href='" + $a.attr("data-url") + "'>" + $a.attr("data-name") + "</a>";
    } else {
        var newa = "<a data-rel='" + $a.attr("data-rel") + "' data-name='" + $a.attr("data-name") + "' href='" + $a.attr("data-url") + "'></a>";
    }


    $(".ListWrapper > ul").find(".MenuHeader").remove();
    $(".ListWrapper > ul:first-child").prepend("<div class='row MenuHeader'><div class='col-xs-24 MenuBackItem'><li class='ListWrapperHeader'><a href='javascript:;'><div class='left-gift'></div><span>GERİ</span></a></li></div><div class='col-xs-24 MainCatalog'>" + newa + "</div></div>");
}); 


$(".mainItem .OpenChildrenMenu > a,.subItem .SubNavItem > a").live("click", function () {

    $(this).parents(".subItem").children("div:nth-child(3)").addClass("ShowSubWrapper");

    $a = $(this).parents(".subItem").children(".SubNavItem").children("a");

    $("#MainMenu").animate({ scrollTop: 0 }, 500, 'swing', function () { });
    var newa = "<a data-rel='" + $a.attr("data-rel") + "' href='" + $a.attr("href") + "'>" + $a.html() + "</a>";

    $(".ShowSubWrapper > .ListWrapper > ul").find(".MenuHeader").remove();
    $(".ShowSubWrapper > .ListWrapper > ul:first-child").prepend("<div class='row MenuHeader'><div class='col-xs-24 MenuBackItem'><li class='ListWrapperHeader'><a href='javascript:;'><div class='left-gift'></div><span>GERİ</span></a></li></div><div class='col-xs-24 MainCatalog'>" + newa + "</div></div>");
});

$(".ShowWrapper > .ListWrapper > ul > .MenuHeader > .MenuBackItem > .ListWrapperHeader > a").live("click", function () {
    CloseShowWrapper();
});

$(".ShowSubWrapper .ListWrapperHeader a").live("click", function () {
    $(this).parents(".itemsWrapper").first().removeClass("ShowSubWrapper");
});

